export default __webpack_public_path__ + "static/media/shape3.514860d0.svg";